import { render, staticRenderFns } from "./c-simple-dialog.vue?vue&type=template&id=7559fc74&scoped=true&"
import script from "./c-simple-dialog.vue?vue&type=script&lang=js&"
export * from "./c-simple-dialog.vue?vue&type=script&lang=js&"
import style0 from "./c-simple-dialog.vue?vue&type=style&index=0&id=7559fc74&lang=scss&scoped=true&"
import style1 from "./c-simple-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7559fc74",
  null
  
)

export default component.exports